import { Pipe, PipeTransform } from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { canDownloadAsset } from '../lib/can-download-asset';

@Pipe({
  name: 'canDownloadAsset',
  standalone: true,
})
export class CanDownloadAssetPipe implements PipeTransform {
  transform(asset: AssetDto, gallery: GalleryDto, galleryPermissions: GalleryDto['permissions']): boolean {
    return canDownloadAsset(asset, gallery, galleryPermissions);
  }
}
